import { IDrop } from "src/core/drops/api/drops.api";

/**
 * Function for formatting a drop name
 * e.g: branchName (BranchNumber)
 * @param branch - branch object
 * @returns formatted drop name
 */
export const formatDropName = (branch: Pick<IDrop, "branchNumber" | "name">, reverse = false): string => {
  let formattedDrop = "";

  if (branch) {
    if (reverse) {
      if (branch.branchNumber) {
        formattedDrop += ` (${branch.branchNumber})`;
      }

      if (branch.name) {
        formattedDrop += ` ${branch.name}`;
      }
    } else {
      if (branch.name) {
        formattedDrop += ` ${branch.name}`;
      }

      if (branch.branchNumber) {
        formattedDrop += ` (${branch.branchNumber})`;
      }
    }
  }

  return formattedDrop;
};
